const FAQ = ({question, answer}: {question: string, answer: string}) => {
    return (
        <div className='flex-row py-4 px-10 lg:px-0'>
            <h3 className='text-3xl font-bold'>{question}</h3>
            <p className='mt-5'>{answer}</p>
        </div>
    )
}

export default FAQ;